import { Component, OnInit } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl} from '@angular/forms';
import {URLSearchParams} from '@angular/http';



@Component({
  selector: 'app-adminsubpartnerservicequota',
  templateUrl: './adminsubpartner-servicequota.component.html',
  styleUrls: ['./adminsubpartner.component.css']
})
export class AdminsubpartnerServicequotaComponent implements OnInit {
 
  ServiceList: any = [];
  PartnerTrx: any = [];
  ServiceTrx: any = [];
  ServiceQuota: any = [];
  aboutme : [];

  table_load = true
  subpartnerid : number;
  subpartner : any;

  constructor(
  public partnerService: ApiPartnerService,
  private route: ActivatedRoute,
  private router: Router
    ) { 
  	
  }

  ngOnInit() {
    this.loadStart();
  }
  
  refreshPage() {
    this.ngOnInit();
  }

  loadStart() {
    let id = this.route.snapshot.paramMap.get('id'); // subpartner
    this.subpartnerid = parseInt(id); // subpartner
    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        console.log(params); // {order: "popular"}
        // this.loadServiceQuota(id);
        this.loadServiceQuotapartner(id);

      });
  }

  loadServiceQuota(id: any)
  {
    this.table_load = true
    return this.partnerService.GetPartnerServiceQuota('?partnerid='+id).subscribe((output: any) => {
        console.log(output);
        this.ServiceList = output['data'];
        this.table_load = false
      })
  }  
  loadServiceQuotapartner(id: any)
  {
    this.table_load = true
    return this.partnerService.GetViewSubpartnerServiceQuota(id).subscribe((output: any = []) => {
        //console.log(output);
        this.ServiceList = output.data;
        this.subpartner = output.subpartner;
        this.table_load = false
      })
  }  

  _partnername()
  {
    return this.subpartner.name;
  }

  loadTrx(item: any) {
    let data = {
      "partnerid": item.partnerid,
      "subpartnerid": item.subpartnerid,
      "productid": item.productid
    };

    return this.partnerService.GetPartnerServiceTrx(data).subscribe((output: any) => {
      console.log(data);
      this.PartnerTrx = output.data;
      this.ServiceTrx = output.data.servicetransaction;
      console.log(output.data);
    })
  }
  
}
